import styled from '@emotion/styled';
import NoLoginPage from 'components/layout/newOnboarding/NoLogInPage';
import Button from "components/ui/Button";

import { usePostInputUserDetail } from "hooks/api"
import { useState, useEffect } from 'react';
// import { useDaumPostcodePopup } from 'react-daum-postcode';
import { useNavigate } from 'react-router-dom';
import ReactGA from "react-ga4";
import SearchAddressModal from "./searchAddressModal";
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';

interface DetailInfo {
  name?:string;
  mobile?:string;
  postalNumber: string;
  defaultAddress: string;
  zoneCode: string;
  detailAddress?:string;
};

const Elem:React.FC<any> = () => {
  const { mutateAsync : postInputUserDetail } = usePostInputUserDetail();
  const [ detailInfo, setDetailInfo ] = useState<DetailInfo>({
    name:"",
    mobile:"",
    postalNumber: "",
    defaultAddress: "",
    zoneCode:"",
    detailAddress:""
  });
  const [ showModal, setShowModal ]   = useState(false);
  
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const navigator = useNavigate();
  // const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

  const closeModal = () => {
    if (showModal === true) return setShowModal(false);
  }

  const handleClick = async ()=> {
    if (showModal === true) {
      return setShowModal(false)
    } else {
      setShowModal(true);
    }
    
    
    // await open({ onComplete: handleComplete})
  };

  // const open = useDaumPostcodePopup(scriptUrl);

  const handleComplete = async (data:any) => {
    setDetailInfo(prevInfoData => ({
      ...prevInfoData,
      postalNumber: data?.zonecode || "",
      defaultAddress : data?.address || "",
      zoneCode: data?.jibunAddress || ""
    }))
    setShowModal(false);
  };

  const handleName = (event:any) => {
    setDetailInfo({
      ...detailInfo , name: event?.target.value, 
    })
  };

  const handlePhone = (event:any) => {
    setDetailInfo({
      ...detailInfo, mobile: event.target.value
    })
  };

  const handleDetailAddress = (event:any)=> {
    setDetailInfo({
      ...detailInfo, detailAddress: event.target.value
    })
  };

  const UploadUerDetail = async () => {
    const result = await postInputUserDetail({
      detailInfo
    })
  }
  
  const handleGoToPlan = async () => {
    if (detailInfo.name && detailInfo.mobile && detailInfo.postalNumber && detailInfo.defaultAddress && detailInfo.detailAddress) {
      // ReactGA.event({
      //   "category": "Button",
      //   "action" : "Click",
      //   "label" : "1/3 complete: user detail"
      // })

      await UploadUerDetail();

      const fbc = Cookies.get('_fbc') || "";
      ReactPixel.fbq("track", "CompleteRegistration", {
        content_name: 'Free Trial Photos',
        content_category: 'Free Trial',
        value: 0,
        currency: "KRW",
        country: "KR",
        gender: "female",
        content_type: 'product',
        fbc: fbc
      })
      navigator("/onboarding/3/credit");
    }
  };

  useEffect(() => {
  },[showModal])

  useEffect(() => {
    if (gaId) {
      const user = localStorage.getItem('name');
      const previousUrl = document.referrer;
      ReactGA.set({
        referrer: previousUrl,
        user_id:user
      })
      ReactGA.send({ hitType: "pageview", page:"/onboarding/2/detail", title: "input user detail view" })
    }
  },[])
  


  return (
    <NoLoginPage disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="first"><span>1/2</span>단계</SmallText>
            <BigText>어디로 받아 보시겠어요?</BigText>
            <SmallText className="small">1~2일내 사진이 무료 배송되어요</SmallText>
          </TextContainer>
          <ContextContainer>
            <SmallText>이름</SmallText>
            <TextInput 
              type="text"
              placeholder="김포티"
              onChange={handleName}
            ></TextInput>
            <SmallText className="Second">휴대전화 번호</SmallText>
            <TextInput 
              type="text"
              placeholder="0000000000"
              onChange={handlePhone}
              ></TextInput>
            <SecontTextContainer>
              <SmallText>배송지</SmallText>
              <FirstLine>
                <TextInput 
                  className="small"
                  placeholder="우편번호"
                  value={detailInfo.postalNumber || ""}/>
                <ButtonContainer>
                  <SearchAddressButton 
                    onClick={handleClick}
                  >
                    주소 검색
                  </SearchAddressButton>
                </ButtonContainer>
              </FirstLine>
              <TextInput 
                className="default"
                placeholder="주소"
                value={detailInfo.defaultAddress || ""}
                />
              <TextInput 
                className="default" 
                placeholder="상세 주소를 입력하세요"
                type="text"
                onChange={handleDetailAddress}
                value={detailInfo.detailAddress || ""}
              />
            </SecontTextContainer>
          </ContextContainer>
          <ButtonWrapper>
            <SubmitButton 
              layoutVariant="contained"
              variant="default"
              expand
              isActive={
                !!(detailInfo.name 
                  && detailInfo.mobile
                  && detailInfo.postalNumber
                  && detailInfo.defaultAddress
                  && detailInfo.detailAddress
                )
              }
              onClick={handleGoToPlan}
            >
              다음
            </SubmitButton>
          </ButtonWrapper>
        </Body>
        <SearchAddressModal showModal={showModal} closeModal={closeModal} handleComplete={handleComplete} />
      </Container>
    </NoLoginPage>
  );
};

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 85vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F3EF;
  padding: 24px 17px;
`;
const Body = styled.div`
  /* max-width: 320px; */
  width: 100%;
  margin: 0 auto;
`
const TextContainer = styled.div`
  /* max-width: 220px; */
  height: 50px;
  display: flex;
  flex-direction: column;

  @media (max-width:321px) {
    margin-left: 0px;
  }
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 100%;
  color: #141414;
  @media (max-width:321px) {
    font-size: 10px;
  }

  span {
    font-weight: 700;
  }
  &.first {
    margin-bottom: 15px;
  }
  &.Second {
    margin-top: 12.37px;
  }

  &.small {
    margin-top: 10px;
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;
  font-weight: bold;
  letter-spacing: -0.03em;
  @media (max-width:321px) {
    font-size: 20px;
  }

  &.Top {
    font-weight: 500;
    margin-bottom: 5px;
  }

  &.Bottom {
    font-weight: 300;
  }
`;
const ContextContainer = styled.div`
  /* max-width: 327px; */
  height: 356px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 321px) {
    margin-top: 30px;
  }
`;
const TextInput = styled.input`
  max-width: 100%;
  height: 45.7px;
  border-radius: 6px;
  margin-top: 8.8px;
  padding-left: 10px;

  ::placeholder {
    color: #AFAFAF;
    opacity: 0.8;
  } 

  &.default {
    margin-top: 7.61;
  }

  &.small {
    max-width: 218.93px;
    width: 65%;
    margin-top: 0px ;

    @media (max-width:321px) {
      width: 56%;
    }

  }
`;
const SecontTextContainer = styled.div`
  width: 100%;
  height: 175.14px;
  margin-top: 30.46px;
  display: flex;
  flex-direction: column;
`;
const FirstLine = styled.div`
  width: 100%;
  height: 45.69px;
  display: flex;
  flex-direction: row;
  margin-top: 8.8px;
  justify-content: space-between;
`;
const ButtonContainer = styled.div`
  width: 102px;
  height: 100%;
`;
const ButtonWrapper =styled.div`
  height: 52px;
  /* width: 100%; */
  margin: 60px auto 0;

    @media (max-width:321px) {
    margin-top: 25px;
  }

`;

interface ButtonProps {
  isActive:boolean;
}
const SubmitButton = styled(Button)<ButtonProps>`
  background-color: #DBC6A7;
  border-radius: 30px;
  border: 0px solid ${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  /* color :${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)}; */
  color :${({ isActive }) => (isActive? 'white' : `rgba(177, 177, 177, 1)`)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;

const SearchAddressButton = styled.button`
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 6px;
  color: #AFAFAF;
    opacity: 0.8;
`
